import { Component, ViewChild, OnInit, OnDestroy, AfterViewInit, ElementRef, ChangeDetectorRef, Renderer2, NgZone } from "@angular/core";
import { LazyLoadEvent, MessageService } from "primeng/api";
import { NavigationEnd, Router } from "@angular/router";
import { TournamentsService } from "src/app/services/tournamnet.service";
import { StateService } from "src/app/manage/state/service/state.service";
import { TokenStorageService } from "../../services/token-storage.service";
import { RoleService } from "src/app/services/role.service";
import { AuthService } from "src/app/services/auth.service";
import { CommonService } from "src/app/services/common.service";
import { FormArray, FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { environment } from "src/environments/environment";
import { CategoryService } from "src/app/services/category.service";
import { WindowRefService } from "src/app/services/window-ref.service";
import { UserWalletService } from "src/app/services/userWallet.service";
import { WalletpaymentService } from "src/app/services/walletPayments.service";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { BannerService } from "src/app/services/banner.service";
import * as momentNamespace from "moment";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChargesService } from "src/app/services/charges.service";
import { GeoLocationService } from "src/app/services/geo-location.service";
const moment = momentNamespace as any;

@Component({
  selector: "app-tournament",
  templateUrl: "./tournament.component.html",
  styleUrls: ["./tournament.component.scss"],
  providers: [BannerService, MessageService, WindowRefService],
})

export class TournamentComponent implements OnInit, AfterViewInit, OnDestroy { 

  private destroy$ = new Subject<void>();
  private listingObserver: IntersectionObserver;
  public listingDeferredReady: boolean = false;
  public filterLoading: boolean = false;
  public tabLoading: { [key: string]: boolean } = {};
  public tabLoaded: { [key: string]: boolean } = {};
  public readonly skeletonCards = [1, 2, 3, 4];
  public readonly skeletonFilters = [1, 2, 3, 4, 5];
  position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
  public downloadModal: boolean = false;
  public countryCodeList: any[] = []; 
  selectedCountryCode: any;
  thankYouMsg: boolean = false;
  mobilFilter: boolean = false;
  shortingModal: boolean = false;
  activeTab: number = 2;
  countdown: number = 10;
  countdownInProgress: boolean = false;
  isRadioButtonClicked: boolean = true;
  public bannerList: any[];
  isFieldAdded: boolean = false;
  tournamentIds: string[] = [];
  wid: any;
  tname: any;
  mtn: any;
  agn: any;
  withdraw_confirm_status: boolean = false;
  outdate_reg_status: boolean = false;
  emailForm: FormGroup;
  public webBannerImageList: any[] = [];
  public mobileBannerImageList: any[] = [];
  walletdata: any;
  withdrawtournamentData: any;
  added_amount: number = 0;
  public comingSoonMsg = environment.comingSoonMsg;
  isLoggedIn: boolean = false;
  duplicateEmailError: boolean = false;
  public totalRecords = 0;
  public errorMessage: string;
  public registrationCategoryErrorMessage: string = null;
  tournamentList: any;
  imagedataa: any;
  tournamentid: any;
  private lazyLoadEvent: LazyLoadEvent;
  private lazyLoadEventPastTournament: LazyLoadEvent;
  private lazyLoadEventCurrentTournament: LazyLoadEvent;
  public cityList: any[] = [];
  public statelist: any[] = [];
  public academylist: any[] = [];  
  public stateName = [];
  public stateCode;
  public cityCode = [];
  public cityName = [];
  /**Wallet Part start */
  registeredtournamentdata: any[] = [];
  submitted = false;
  totalCash: number = 0;
  totalleftCash: number;
  myForm: FormGroup;
  totalCoins;
  /**Wallet Part end */
  /* Login Part */
  public loggedinUserrole;
  public showRegisterButton: boolean = true;
  forgotPassForm: FormGroup;
  mobileLoginForm: FormGroup;
  genders;
  message;
  showMessage: boolean = false;
  selectedGender: any = null;
  userData;
  search_email: any;
  partner_email_index: any;
  /*Category Listing */
  public selectedmatchType;
  tournamentId: any;
  public selectedageGroup;
  public pagination = environment.pagination;
  loginemailid;
  trainerRoleId;
  permissions: any[] = [];  
  rolelist: any[] = [];
  doublecatarray: any;
  partneremailid: any;
  partneremailemail: any = null;
  emailerrormsg: boolean = false;
  public mobileNumber;
  public successMessage;
  @ViewChild("ngOtpInput", { static: false }) ngOtpInput: any;
  /**Login part */
  public showForgotPasswordForm: boolean = false;
  public showResendButton: boolean = false;
  public loading: boolean = false;  
  public loggedInUser;
  public stateList: any[] = [];
  public countryName;
  public countryCode;
  parentcatList: any[] = [];
  tourcatList: any[];
  tournamentname: any;
  withdrawButtonClicked: boolean = false;
  selectedEntryFees: number[] = [];
  selectedAgeGroupIndices: number[] = [];
  walletBalance: number;
  /** Add Cash Part */
  addCashForm: FormGroup;
  public userId;
  pastTournamentList: any;
  public pastTotalRecords = 0;
  currentTournamentList: any;
  currentTotalRecords: any;
  paymentId: any;
  showPmdtaNumber: boolean;
  selectedTournamentCityName: any;
  showDoublePmdtaNumber: boolean = false;  
  termsAndConditions: any;
  addPartnerTermsAndConditions: any;
  walletDialogTermsAndConditions: any;
  termsAndConditionsCheck: boolean;
  showTermsAndConditionError: boolean;
  isContestVerified: boolean;
  isAbove18Check: any;
  pageNumberFirst: any;
  pageLimitFirst: number;  
  onTournamentTabChange: boolean = false;
  categoryAndAgeGroupList: any[] = [];
  selectedCategoryAndAgeGroupList: any[] = [];
  disableCategories: boolean[] = [];
  originalCategoryAndAgeGroupList: any;
  isTournamentCatgeorySelected: boolean = false;
  selectableCategoryList: any[] = [];
  fullCategoryList: any[] = [];
  categoryList: any[] = [];
  tournamentName: string = null;
  statelistData: any[] = [];
  cityListData: any[] = [];
  academyListData: any;
  rangeDates: Date[];
  selectedStartDateRange: Date[];
  visible: boolean = false;
  TournamentEntry: boolean = false;
  addPartner: boolean = false;
  Walletdialog: boolean = false;
  Addcashmodal: boolean = false;
  thanYoumodal: boolean = false;
  WithdrawModal: boolean = false;
  WithdrawcnfModal: boolean = false;
  thankwithdraw: boolean = false;
  displayCashMs: boolean = false;
  outputText: string;
  public academyId = [];
  selectedcourtType;
  public courtTypeList = environment.courtTypeList;  
  selectedAgeGroups: string[] = [];
  selectedFieldGroups: any[];
  selectedEntryFee: number = 0;
  selectedTournamentCategory: string[] = []; // Explicitly type as string[]
  selectedAgeGroup: string[] = []; // Explicitly type as string[]
  showDoublesPartnerSection: boolean = false;
  addedAmount: number | null = null;
  public yearlist = [];
  showAddMoneyMessage: boolean = false;
  public currentDate = new Date();
  public currentYear = this.currentDate.getFullYear();
  public selectedMonth;
  public selectedYear = [this.currentDate.getFullYear()];
  filterByAgeCategorySelected = [];
  filterByMatchCategorySelected = [];
  public isLoggedin: boolean = false;
  public loginmobileNumber;
  welcomeLogin: boolean = false;
  selectedState: any = [];
  selectedCity: any = [];
  selectedCategories: any = [];
  selectedAcademy: any = [];
  selectedFilterYear: any = [];
  private searchSubject = new Subject<string>();
  searchedStateName: string = null;
  searchedCityName: string = null;
  searchedAcademyName: string = null;
  sortByPriceValue:string = null;
  fees: any;
  refundTournamentCategoriesMessage: string | null = null;
  isRefundTournamentCategoriesCompleted: boolean = false;
  latitude: string | null = null;
  longitude: string | null = null;
  private isUserLocationReady: boolean = false;
  private loadTournamentAfterLocationReady: boolean = false;
  isYearFilterSelected: boolean = false;
  showNoCategories: boolean = false;
  lastdateofregistration: any;
  isRegistrationExpired = false;
  registrationDeadlineTimer: any;
  outdate_withdraw_status: boolean = false;
  lastdateofwithdraw: any;


  constructor(private renderer: Renderer2, private categoryService: CategoryService, private bannerService: BannerService, private tournamentsService: TournamentsService, private stateService: StateService, private formBuilder: FormBuilder, private tokenStorage: TokenStorageService, private roleService: RoleService, private authService: AuthService, private fb: FormBuilder, private walletpaymentService: WalletpaymentService, private tournamentService: TournamentsService, private userWalletService: UserWalletService, private winRef: WindowRefService, private cdr: ChangeDetectorRef, private elementRef: ElementRef, private route: Router, private commonService: CommonService,
    private chargesService: ChargesService, private ngZone: NgZone, private geoLocationService: GeoLocationService) {
    this.myForm = this.fb.group({
      fields: this.fb.array([]), // You might need to initialize this properly based on your use case
    });
    this.emailForm = new FormGroup({
      phoneCode: new FormControl(""),
      mobileNumber: new FormControl("", [
        Validators.required,
        Validators.maxLength(10),
      ]),
    });
  }
  
  ngOnInit(): void {
    this.renderer.addClass(document.body, 'tournamentPage');
    this.getCountryCodes();
    this.roleService.setCurrentActiveRoute(this.route.url);
    var currentYear = new Date().getFullYear();
    setTimeout(() => {
      this.hideDiv();
    }, 20000); // Hide the div after 2000 milliseconds (2 seconds)
    this.resetCountdown();
    this.getWebBanner();
    /**API call for Logedin user Join tournament list Start */
    this.loggedInUser = this.tokenStorage.getUser();
    if (Object.keys(this.loggedInUser).length > 0) {
      this.isLoggedin = true;
      this.isContestVerified = this.loggedInUser.userdata.isContestVerified;
      this.isAbove18Check = this.loggedInUser.userdata.isAbove18;
      this.loggedinUserrole = this.loggedInUser.userdata.rolename;
      if (this.loggedinUserrole === "academy") {
        this.showRegisterButton = false;
      } else {
        this.showRegisterButton = true;
      }
      if (this.cityName.includes("Pune")) {
        this.showPmdtaNumber = true;
      } else {
        this.showPmdtaNumber = true;
      }
      this.tournamentsService.getTournamentIds(this.loggedInUser.userdata.id).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.tournamentIds = data;
      },
      (error: any) => {
        console.error("Error getting tournament IDs:", error);
      });
    } else {
      this.showRegisterButton = true;
      this.isLoggedin = false;
    }
    /**API call for Logedin user Join tournament list End */
    const storedWalletBalance = localStorage.getItem("walletBalance");
    if (storedWalletBalance) {
      this.walletBalance = storedWalletBalance
        ? parseFloat(storedWalletBalance)
        : 0;
    } else {
      this.walletBalance = 0;
    } 
    // for (let i = currentYear; i <= 2040; i++) {
    //   this.yearlist.push({ label: i, value: i });
    // }
    //this.getAllTournamentCategories();
    this.myForm = this.fb.group({
      fields: this.fb.array([this.createFieldGroup()]),
    });
    this.addCashForm = this.formBuilder.group({
      amount: [null, [Validators.required]],
    });
    /*Login part */
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser && this.loggedInUser.userdata) {
      this.isLoggedIn = true;
    }
    this.forgotPassForm = new FormGroup({
      email: new FormControl("", [
        Validators.required,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}"),
      ]),
    });
    this.mobileLoginForm = this.formBuilder.group({
      mobileNumber: [
        null,
        [Validators.required, Validators.pattern("[0-9 ]{10}")],
      ],
    });
    this.route.events.pipe(takeUntil(this.destroy$)).subscribe((events)=>{
      if(events instanceof NavigationEnd) {
        if(!(events.url.includes('/tournament') || events.url.includes('/result') || events.url.includes('/player-list'))) {
          let initialTournamentPaginationvalues = { page: 1, limit: 10, tab: 2 };
          window.localStorage.setItem('tournament-pagination',JSON.stringify(initialTournamentPaginationvalues));
        }
      }
    })
    this.genders = [
      { id: "1", name: "Male", code: "Male" },
      { id: "2", name: "Female", code: "Female" },
      { id: "3", name: "Other", code: "Other" },
    ];
    this.selectedGender = this.genders[0];
    this.filterLoading = true;
    //this.getStates(false, "IN");
    //this.getTournamentsLocation();
    this.getUserBalance();
    this.tournamentsService.findBySlug().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.doublecatarray = data;
    });
    this.fetchSearchResults();    
    this.getPlatformAndConvenienceFees();
    this.getUserLocation();
  }

  ngAfterViewInit(): void {
    this.setupDeferredListingLoad();
  }

  private setupDeferredListingLoad(): void {
    const listingSection = this.elementRef.nativeElement.querySelector('.tournament-list-main');

    if (!listingSection || !('IntersectionObserver' in window)) {
      this.loadTournamentListingSection();
      return;
    }

    this.listingObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        this.ngZone.run(() => {
          this.loadTournamentListingSection();
          this.cdr.detectChanges();
        });
        this.listingObserver.unobserve(entry.target);
      });
    }, {
      root: null,
      rootMargin: '450px 0px',
      threshold: 0.01,
    });

    this.listingObserver.observe(listingSection);
  }

  private loadTournamentListingSection(): void {
    if (this.listingDeferredReady) {
      return;
    }

    this.listingDeferredReady = true;
    this.getTournamentfilterData();
    this.loadActiveTournamentTabWhenLocationReady();
  }

  private getActiveTabKey(): string {
    return ['past', 'current', 'upcoming'][this.activeTab] || 'upcoming';
  }

  private loadActiveTournamentTab(event?: LazyLoadEvent): void {
    const activeTabKey = this.getActiveTabKey();

    if (activeTabKey === 'past') {
      this.loadPastTournament(event || this.lazyLoadEventPastTournament);
      return;
    }

    if (activeTabKey === 'current') {
      this.loadCurrentTournament(event || this.lazyLoadEventCurrentTournament);
      return;
    }

    this.loadTournament(event || this.lazyLoadEvent);
  }

  private refreshVisibleTournamentData(): void {
    if (!this.listingDeferredReady) {
      this.loadTournamentListingSection();
      return;
    }

    this.loadActiveTournamentTabWhenLocationReady();
  }

  private loadActiveTournamentTabWhenLocationReady(): void {
    if (this.isUserLocationReady) {
      this.loadActiveTournamentTab();
      return;
    }

    this.loadTournamentAfterLocationReady = true;
  }

  private completeUserLocationLookup(): void {
    if (this.isUserLocationReady) {
      return;
    }

    this.isUserLocationReady = true;
    if (this.loadTournamentAfterLocationReady) {
      this.loadTournamentAfterLocationReady = false;
      this.loadActiveTournamentTab();
    }
  }

  getPlatformAndConvenienceFees() {
    this.chargesService.getPlatformAndConvenienceFees().subscribe((data:any) => {
      this.fees = data.data.items.map(ele => ele.fees.tournament)[0];
    }, err => {
        this.errorMessage = err.error.message;
    })
  }

  getPriceFormControlName(index: number): string {
    return `price_${index}`;
  }

  isRegisterButtonEnabled(): boolean {
    return this.showAddMoneyMessage = false;
  }

  getUserLocation() {
    this.geoLocationService.getGeoLocation().pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.latitude = data.latitude;
      this.longitude = data.longitude;
      this.completeUserLocationLookup();
    }, () => {
      this.completeUserLocationLookup();
    })
  }

  onSearchTournament(searchTerm: string) {
    this.searchSubject.next(searchTerm.trim());
  }
  
  fetchSearchResults() {
    this.searchSubject.pipe(debounceTime(500),                // Wait 500ms after typing stops
        distinctUntilChanged(),            // Only trigger if query changed
      ).pipe(takeUntil(this.destroy$)).subscribe((searchTerm) => {
        if (searchTerm !== '' && searchTerm !== null) {
          this.tournamentName = searchTerm;
        } else {
          this.tournamentName = '';
        }
        this.refreshVisibleTournamentData();
      });
  }

  resetCountdown(): void {
    this.countdown = 10;
    this.countdownInProgress = false;
  }

  onForgotPassSubmit() {
    this.submitted = true;
    if (this.forgotPassForm.valid) {
      this.authService.requestPassword(this.forgotPassForm.value).pipe(takeUntil(this.destroy$)).subscribe(
        (res) => {
          if (res["errors"]) {
            this.errorMessage = res["errors"];
            this.successMessage = "";
          } else {
            this.successMessage = res;
            this.errorMessage = "";
          }
          this.showMessage = true;
          setTimeout(() => {
            this.submitted = false;
            this.forgotPassForm.reset();
            this.showMessage = false;
            this.successMessage = "";
          }, 2000);
        },
        (err) => {
          this.successMessage = "";
          this.showMessage = true;
          this.errorMessage = err.error.data.errors;
        }
      );
    }
  }

  getParentCategory() {
    var query = "?filterByDisable=false&filterByStatus=true&getOnlyParent=true";
    this.categoryService.getCategoryList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.parentcatList = data.data.items;
        this.tokenStorage.saveCategorylist(this.parentcatList);
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getRoleDetails() {
    const querystring = "filterByroleId=" + this.userData.data.userdata.role;
    this.roleService.getRoleListWithoutAuth(querystring).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.trainerRoleId = data.data.items[0]["id"];
        this.permissions = data.data.items[0]["permissions"];
        this.tokenStorage.saveUserPermissions(this.permissions);
        this.rolelist = data.data.items[0];
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  
  getRoleList() {
    var querystring = "filterByDisable=false&filterByStatus=true";
    var rolearray = [];
    this.roleService.getRoleListWithoutAuth(querystring).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        var rolelist = data.data.items;
        rolelist.forEach((element) => {
          rolearray.push({
            roleid: element.id,
            rolename: element.user_role_name,
          });
        });
        if (rolearray.length > 0) {
          this.tokenStorage.saveRolelist(rolearray);
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getAllTournamentCategories() {
    this.categoryService.getCategoryListV2().pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.categoryList = data.data;
      },
      err => {
        this.errorMessage = err.error.message;
      }
    )
  }

  get fieldsFormArray() {
    return this.myForm.get("fields") as FormArray;
  }

  createFieldGroup() {
    return this.fb.group({
      matchTypeId: ["", Validators.required],
      ageGroupId: ["", Validators.required],
      categories: ["", Validators.required],
      doublePlayerId: [""],
      doubleUserEmail: [""],
      entryFee: [0],
      maxPlayer: [],
      tournamentCategoryId: [],
    });
  }

  addField() {
    if (this.fieldsFormArray.length > 0) {
      let matchTypeIdValue = this.fieldsFormArray.controls[this.fieldsFormArray.length - 1]['controls']['matchTypeId'].value;
      let ageGroupIdValue = this.fieldsFormArray.controls[this.fieldsFormArray.length - 1]['controls']['ageGroupId'].value;
      if (matchTypeIdValue && ageGroupIdValue) {
        let index = this.categoryAndAgeGroupList.findIndex(({ matchTypeId, ageGroupId }) => (matchTypeId === matchTypeIdValue && ageGroupId === ageGroupIdValue));
        this.disableCategories[this.fieldsFormArray.length - 1] = true;
        if (index !== -1) {
          this.selectedCategoryAndAgeGroupList.push(this.categoryAndAgeGroupList.find(({ matchTypeId, ageGroupId }) => (matchTypeId === matchTypeIdValue && ageGroupId === ageGroupIdValue)));
          this.categoryAndAgeGroupList.splice(index,1);
        }
      }
    }
    this.fieldsFormArray.push(this.createFieldGroup());
    if (this.fieldsFormArray.length > 1) {
      this.disableCategories[0] = true;
    }
    this.disableCategories.push(false);
    this.calculateTotalEntryFee();
    this.totalleftCash = this.walletBalance - this.totalEntryFee();
    this.isFieldAdded = true;
    this.resetDoublesPartnerSection();
    this.isTournamentCatgeorySelected = false;
    this.refreshCategoryLists();
  }

  resetDoublesPartnerSection() {
    this.showDoublesPartnerSection = false;
  }

  removeField(index: number) {
    let matchTypeIdValue = this.fieldsFormArray.controls[index]['controls']['matchTypeId'].value;
    let ageGroupIdValue = this.fieldsFormArray.controls[index]['controls']['ageGroupId'].value;
    this.fieldsFormArray.removeAt(index);
    this.isTournamentCatgeorySelected = this.fieldsFormArray.value.every(ele => ele.matchTypeId !== '');
    if (matchTypeIdValue && ageGroupIdValue) {
      let selectedIndex = this.selectedCategoryAndAgeGroupList.findIndex(({ matchTypeId, ageGroupId }) => (matchTypeId === matchTypeIdValue && ageGroupId === ageGroupIdValue));
      this.categoryAndAgeGroupList.push(this.selectedCategoryAndAgeGroupList.find(({ matchTypeId, ageGroupId }) => (matchTypeId === matchTypeIdValue && ageGroupId === ageGroupIdValue)));
      this.selectedCategoryAndAgeGroupList.splice(selectedIndex,1);
    }
    this.disableCategories.splice(index, 1);
    if (this.fieldsFormArray.length === 1) {
      this.categoryAndAgeGroupList.push(...this.selectedCategoryAndAgeGroupList);
      this.selectedCategoryAndAgeGroupList = [];
      this.disableCategories[0] = false;
    }
    this.selectedEntryFees.splice(index, 1);
    this.calculateTotalEntryFee();
    this.totalleftCash = this.walletBalance - this.totalEntryFee();
    this.refreshCategoryLists();
  }

  getTournamentCategoryData(id) {
    this.tournamentsService.getTournamentscat(id).pipe(takeUntil(this.destroy$)).subscribe((response) => {
      this.tourcatList = response.items;
      this.tourcatList.unshift({
        matchTypeId: "",
        matchTypeName: "Select",
        cityname: "",
      });
    },
    (error) => {
      console.error("Error fetching data:", error);
    });
  }

  tournamentMaxPlayerCapacityCheckFunc(event) {
    const tournamentId = this.tournamentid;
    const matchTypeId = event.value.matchTypeId;
    const ageGroupId = event.value.ageGroupId;
    const query = `matchTypeId=${matchTypeId}&ageGroupId=${ageGroupId}`;
    this.tournamentsService.getTournamentMaxPlayerCapacity(tournamentId,query).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      // console.log('data : ',data);
    }, (error) => {
      this.errorMessage = error.error.message;
    })
  }

  onTournamentCategorySelect(event, index) {
    if (this.isCategoryFull(event.value)) {
      this.registrationCategoryErrorMessage = `${event.value.categoryName} - Category is Full`;
      this.errorMessage = this.registrationCategoryErrorMessage;
      this.myForm.controls['fields']['controls'][index]['controls']['categories'].setValue(null);
      return;
    }
    this.registrationCategoryErrorMessage = null;
    const selectedMatchType = event.value.matchTypeId;
    this.isTournamentCatgeorySelected = (!selectedMatchType) ? false : true;
    this.myForm.controls['fields']['controls'][index]['controls']['matchTypeId'].setValue(event.value.matchTypeId);
    this.myForm.controls['fields']['controls'][index]['controls']['ageGroupId'].setValue(event.value.ageGroupId);
    const doubleUserEmailControl =
    this.fieldsFormArray.controls[index].get("doubleUserEmail");
    if (this.doublecatarray.includes(selectedMatchType)) {
      this.elementRef.nativeElement.querySelector(
        "#add_double_partner_" + index
      ).style.display = "block";
      doubleUserEmailControl.setValidators(Validators.required);
    } else {
      this.myForm.value.fields[index].doublePlayerId = "";
      this.myForm.value.fields[index].doubleUserEmail = "";
      this.elementRef.nativeElement.querySelector(
        "#add_double_partner_" + index
      ).style.display = "none";
      this.elementRef.nativeElement.querySelector(
        "#double_partner_" + index
      ).style.display = "none";
      doubleUserEmailControl.clearValidators();
    }
    doubleUserEmailControl.updateValueAndValidity();
    const selectedAgeGroup = event.value.ageGroupId;
    this.selectedAgeGroups[index] = selectedAgeGroup;
    this.selectedAgeGroupIndices[index] = index;
    // Check if subAgegroup for the specific index exists and is not undefined
    if (
      this.categoryAndAgeGroupList &&
      Array.isArray(this.categoryAndAgeGroupList) &&
      this.categoryAndAgeGroupList.length > 0
    ) {
      if (event.value.entryFee) {
        this.selectedEntryFee = event.value.entryFee;
      } else {
        this.selectedEntryFee = 0;
      }
      this.myForm.value.fields[index].entryFee = event.value.entryFee;
      this.myForm.value.fields[index].maxPlayer =
        event.value.maxPlayer;
      this.myForm.value.fields[index].tournamentCategoryId =
        event.value._id;
      if (event.value.entryFee) {
        this.selectedEntryFees[index] = event.value.entryFee;
      } else {
        this.selectedEntryFees[index] = 0;
      }
      this.calculateTotalEntryFee();
      this.myForm.controls["fields"]["controls"][index]
        .get("entryFee")
        .setValue(event.value.entryFee);
      this.myForm.controls["fields"]["controls"][index]
        .get("tournamentCategoryId")
        .setValue(event.value._id);
      this.myForm.controls["fields"]["controls"][index]
        .get("maxPlayer")
        .setValue(event.value.maxPlayer);
    } else {
      this.selectedEntryFee = 0; // Set a default value if the subAgegroup data is empty or undefined
    }
    this.refreshCategoryLists();
  }

  totalEntryFee(): number {
    const fixedSelectedEntryFees = this.selectedEntryFees.reduce((total, fee) => total + fee, 0);
    let selectedEntryFees = this.selectedEntryFees.reduce((total, fee) => total + fee, 0);
    if (this.fees?.platformFeeStatus) {
      if (this.fees?.platformFeeType === 'flat') {
        selectedEntryFees += this.fees?.platformFee;
      } else {
        selectedEntryFees += ((this.fees?.platformFee * fixedSelectedEntryFees) / 100);
      }
    }
    if (this.fees?.convenienceFeeStatus) {
      if (this.fees?.convenienceFeeType === 'flat') {
        selectedEntryFees += this.fees?.convenienceFee;
      } else {
        selectedEntryFees += ((this.fees?.convenienceFee * fixedSelectedEntryFees) / 100);
      }
    }
    return Math.round(selectedEntryFees);
    // return this.selectedEntryFees.reduce((total, fee) => total + fee, 0);
  }

  calculateTotalEntryFee() {
    this.selectedEntryFee = this.selectedEntryFees.reduce(
      (total, fee) => total + fee,
      0
    );
  }

  walletPay() {
    this.thankYouMsg = false;
    const registrationDeadline = moment(
      this.lastdateofregistration.replace('Z', '')
    );
    const currentTime = moment();
    this.isRegistrationExpired =
    currentTime.isSameOrAfter(registrationDeadline);
    this.Walletdialog = true;
    this.TournamentEntry = false;
    if (this.walletBalance > this.totalEntryFee()) {
      this.onRadioClick();
    } else {
      this.displayCashMs = true;
      this.totalleftCash = this.walletBalance - this.totalEntryFee();
    }
    const formData = this.myForm.value;
    const selectedFieldGroups = formData.fields;
    let loop_count = 0;
    for (const fieldGroup of selectedFieldGroups) {
      const matchtypeValue = fieldGroup.matchTypeId;
      const agegroupValue = fieldGroup.ageGroupId;
      var matchtypeindex = this.originalCategoryAndAgeGroupList.findIndex(
        (item) => item.matchTypeId === matchtypeValue
      );
      fieldGroup.matchname = this.originalCategoryAndAgeGroupList[matchtypeindex].matchTypeName;
      var agegroupindex = this.originalCategoryAndAgeGroupList.findIndex(
        (item) => item.ageGroupId === agegroupValue
      );
      fieldGroup.agegroupname =
        this.originalCategoryAndAgeGroupList[agegroupindex].ageGroupName;
      loop_count++;
    }
    this.selectedTournamentCategory = selectedFieldGroups;
    this.selectedAgeGroup = selectedFieldGroups.map(
      (fieldGroup: any) => fieldGroup.agegroup
    );
  }
  
  get a() {
    return this.addCashForm.controls;
  }

  get forgotPassValidation() {
    return this.forgotPassForm.controls;
  }

  onForgotPassBack() {
    this.showForgotPasswordForm = false;
    this.visible = true;
  }

  getTournamentfilterData(){
    this.filterLoading = true;
    this.tournamentService.getTournamentfilterData().pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.statelistData = JSON.parse(JSON.stringify(res.data.location.statelist));
      this.statelist = this.statelistData;
      this.cityListData = JSON.parse(JSON.stringify(res.data.location.citylist));
      this.cityList = this.cityListData;
      this.academyListData = JSON.parse(JSON.stringify(res.data.location.academylist));
      this.academylist = this.academyListData;
      this.categoryList = res.data.categories;
      this.yearlist = res.data.years;
      this.filterLoading = false;
    }, (err) => {
      this.errorMessage = err.error.message;
      this.filterLoading = false;
    });
  }

  getStates(fromForm, event) {
    this.stateList = [];
    this.stateCode = [];
    this.stateName = [];
    this.cityCode = [];
    this.cityName = [];
    if (fromForm == true) {
      this.countryCode = event.value.iso2;
      this.countryName = event.value.name;
    } else {
      this.countryCode = event;
    }
    let query ="filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" +this.countryCode;
    this.stateService.getstateList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach((element) => {
          let stateObj = {
            name: element.name,
            id: element.id,
          };
          this.stateList.push(stateObj);
        });
      }
    });
  }

  onCategorySelect(event) {
    if (event.checked.length > 0) {
      this.filterByAgeCategorySelected = [...event.checked.map(ele => ele.ageGroupId)];
      this.filterByMatchCategorySelected = [...event.checked.map(ele => ele.matchTypeId)];
    } else {
      this.filterByAgeCategorySelected = [];
      this.filterByMatchCategorySelected = [];
    }
    this.refreshVisibleTournamentData();
  }

  onYearChange(event) {
    this.isYearFilterSelected = (event.checked.length > 0) ? true : false;
    if (event.checked.length > 0) {
      this.selectedYear = [...event.checked.map(ele => ele)];
    } else {
      this.selectedYear = [this.currentYear];
    }
    this.refreshVisibleTournamentData();
  }

  clear() {
    this.selectedState = [];
    this.stateCode = [];
    this.stateName = [];
    this.selectedCity = [];
    this.cityCode = [];
    this.cityName = [];
    this.selectedCategories = [];
    this.filterByAgeCategorySelected = [];
    this.filterByMatchCategorySelected = [];
    this.selectedAcademy = [];
    this.academyId = [];
    this.selectedFilterYear = [];
    this.selectedYear = [this.currentYear];
    this.isYearFilterSelected = false;
    this.rangeDates = null;
    this.selectedStartDateRange = [];
    this.sortByPriceValue = null;
    this.refreshVisibleTournamentData();
    const obj = {
      target: {
        value: ''
      }
    }
    this.onSearchState(obj);
    this.searchedStateName = null;
    this.onSearchCity(obj);
    this.searchedCityName = null;
    this.onSearchAcademy(obj);
    this.searchedAcademyName = null;
  }

  onClickSortButton(event) {
    this.refreshVisibleTournamentData();
  }

  loadTournament(event: LazyLoadEvent) {
    this.tabLoading['upcoming'] = true;
    this.tabLoaded['upcoming'] = true;
    const tabMapping = ['past', 'current', 'upcoming'];
    this.lazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    let query = "filterByDisable=false&filterByStatus=true";
    if (event !== undefined && !this.onTournamentTabChange) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }    
    if (this.tournamentName !== '' && this.tournamentName !== null) {
      query += "&filterByName=" + this.tournamentName;
    }
    if (this.academyId.length > 0) {
      query += "&filterByAcademyIds=" + this.academyId;
    }
    if (this.stateName.length > 0) {
      query += "&filterByStateNames=" + this.stateName;
    }
    if (this.cityName.length > 0) {
      query += "&filterByCityNames=" + this.cityName;
    }
    if (this.selectedcourtType != null) {
      query += "&filterByCourtType=" + this.selectedcourtType;
    }
    if (this.selectedMonth != null) {
      query += "&filterByMonth=" + this.selectedMonth;
    }
    if (this.selectedYear.length > 0) {
      query += "&filterByYears=" + this.selectedYear;
    }
    if (this.filterByAgeCategorySelected.length > 0) {
      query += "&filterByAgeGroupId=" + this.filterByAgeCategorySelected;
    }
    if (this.filterByMatchCategorySelected.length > 0) {
      query += "&filterByMatchGroupId=" + this.filterByMatchCategorySelected;
    }
    if (this.selectedStartDateRange != null) {
      query += "&filterByStartDateRange=" + this.selectedStartDateRange;
    }
    if (this.latitude !== null) {
      query += "&filterByLatitude=" + this.latitude;
    }
    if (this.longitude !== null) {
      query += "&filterByLongitude=" + this.longitude;
    }
    this.pageNumberFirst = pagenumber;
    this.pageLimitFirst = rows;
      query += "&pageSize=" +  rows + "&pageNumber=" + pagenumber;
    if (this.sortByPriceValue !== null) {
      query += "&sortByPrice=entryFee&orderByPrice=" + this.sortByPriceValue;
    } else if (this.latitude !== null && this.longitude !== null) {
      query += "&sortBy=distance&orderBy=ASC";
    } else {
      query += "&sortBy=startdate&orderBy=ASC";
    }
    this.tournamentsService.getTournamentsListWithoutAuth(query).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (event !== undefined) {
        window.scroll(0, 0);
      }
      this.loading = false;
      this.tournamentList = data.data.items;
      this.totalRecords = data.data.totalCount;
      // for (const tournament of this.tournamentList) {
      //   const lastDateOfRegistration = tournament.lastdateofregistration;
      //   if (
      //     moment(this.currentDate).format("YYYY-MM-DD") >
      //     moment(lastDateOfRegistration).format("YYYY-MM-DD")
      //   ) {
      //     this.outdate_reg_status = true;
      //   } else {
      //     this.outdate_reg_status = false;
      //   }
      // }
      if (this.tournamentList.length > 0) {
        this.lastdateofregistration =
          this.tournamentList[0].lastdateofregistration;

        this.lastdateofwithdraw =
          this.tournamentList[0].lastdateofwithdraw;
      }
      for (const tournament of this.tournamentList) {
  let currentdate = moment();

  // Registration deadline
  if (
    moment(tournament.lastdateofregistration)
      .isSameOrBefore(currentdate)
  ) {
    this.showRegisterButton = true;
    this.outdate_reg_status = true;
  } else {
    this.showRegisterButton = true;
    this.outdate_reg_status = false;
  }

  // Withdraw deadline
  if (
    moment(tournament.lastdateofwithdraw)
      .isSameOrBefore(currentdate)
  ) {
    this.outdate_withdraw_status = true;
  } else {
    this.outdate_withdraw_status = false;
  }
}
      this.cdr.detectChanges();
      this.tournamentList.forEach((element) => {
        element.isViewMore = false;
        this.imagedataa = element["academyPic"];
        let groupdt = [];
        if (element["tournamentCategories"]) {
          if (element["tournamentCategories"].length > 0) {
            element["tournamentCategories"].forEach((tmp) => {
              groupdt.push(tmp["matchtypeData"][0]["name"]);
            });
            element.matchtype = groupdt.toString();
          } else {
            element.matchtype = "";
          }
        }
      let cateArray = [];
      if (element.tournamentCategories) {
        element.tournamentCategories.forEach((element) => {
          cateArray.push(
            element.ageGroupData[0].name + " " + element.matchtypeData[0].name
          );
        });
      }
      const heading =
          "_Join_" +
          " _*" +
          element.name +
          "*_ " +
          "_and start climbing up the ranking ladder to win the RTG Scholarship!🎾🏆_ ";
        const subheading = "*🎾Categories:* " + cateArray.join(", ");
        const lastdate =
          "*🗓️Last Date Of Registration:* " +
          moment(element.lastdateofregistration).format("DD-MM-YYYY");
        const startdate =
          "*🗓️Tournament Date:* " +
          moment(element.startdate).format("DD-MM-YYYY");
        const location =
          "*📍Location:* " +
          element.address +
          ", " +
          element.cityname +
          ", " +
          element.statename +
          ", " +
          element.zipcode;
        const link =
          "*Tap on the link to Register:* " +
          environment.frontEnd.domain +
          "/tournaments/factsheet/" +
          element.id;
        const org =
          "*For any queries Contact* " +
          "*" +
          element.academyName +
          "*" +
          " at " +
          "+91 " +
          element.organizercontactnumber;
        const seeyou = "_*Register Now only on the TPL App*_";  
        // Construct the WhatsApp sharing URL
          const message = encodeURIComponent(
            heading +
              "\n" +
              "\n" +
              subheading +
              "\n" +
              lastdate +
              "\n" +
              startdate +
              "\n" +
              location +
              "\n" +
              link +
              "\n" +
              "\n" +
              org +
              "\n" +
              "\n" +
              seeyou +
              "\n" +
              "\n"
          );
        element.shareurl = `https://api.whatsapp.com/send?text=${message}`;
        let tmp = this.courtTypeList.find(
          (o) => o.value === element.courttype
        );
        if (tmp != undefined) {
          element.court = tmp.label;
        } else {
          element.court = "";
        }
        let tmpcat = [];
        let pointsData = [];
        let entryFeeData = [];
        let t = element.tournamentCategories;
        if (t != undefined) {
          t.forEach((catelement) => {
            const matchCategory = [
              {
                matchTypeCategoryId: catelement.matchtypeData[0]?._id,
                matchTypeCategoryName: catelement.matchtypeData[0]?.name,
                ageGroupTypeCategoryId: catelement.ageGroupData[0]?._id,
                ageGroupTypeCategoryName: catelement.ageGroupData[0]?.name,
              }
            ]
            tmpcat.push(matchCategory);
            pointsData.push(catelement.pointStructureData);
            entryFeeData.push(catelement.entryFee);
          });
        }
        let minimumEntryFee = (entryFeeData.length > 0) ? Math.min(...entryFeeData) : null;
        let maximumEntryFee = (entryFeeData.length > 0) ? Math.max(...entryFeeData) : null;
        element.minimumEntryFee = minimumEntryFee;
        element.maximumEntryFee = maximumEntryFee;
        let uniqueData = [];
        let uniqueIds = {};
        tmpcat.forEach((item) => {
            if (item.length > 0) {
              // if (!uniqueIds[item[0]["matchTypeCategoryName"]]) {
              //   uniqueIds[item[0]["matchTypeCategoryName"]] = true;
              //   uniqueData.push(item[0]["matchTypeCategoryName"] + ' ' + item[0]["ageGroupTypeCategoryName"]);
              // }
              uniqueData.push(item[0]["matchTypeCategoryName"] + ' ' + item[0]["ageGroupTypeCategoryName"]);
            }
        });
        let uniquePointsData = [];
        pointsData.forEach((item) => {
          if (!uniquePointsData.includes(item[0]['name'].replace(' Points', ''))) {
            uniquePointsData.push(item[0]['name'].replace(' Points', ''));
          }
        })
        element.matchDataName = uniqueData.length > 0 ? uniqueData : null;
        element.pointsDataName = uniquePointsData;
      });
      this.tabLoading['upcoming'] = false;
    },
    (err) => {
      this.errorMessage = err.error.message;
      this.tabLoading['upcoming'] = false;
    });
    this.onTournamentTabChange = false;
  }

  viewMoreCategoriesToggleOption(tournament) {
    tournament.isViewMore = !tournament.isViewMore;
  }

  pointsDataNameCheckFunc(tournament) {
    let isPoinstDataNamesAvailable = Object.keys(tournament).includes('pointsDataName');
    return isPoinstDataNamesAvailable;
  }

  matchDataNameCheckFunc(tournament) {
    let isMatchDataNamesAvailable = Object.keys(tournament).includes('matchDataName');
    return isMatchDataNamesAvailable;
  }

  onclickTournamentdetails(id) {
    this.route.navigate(["tournaments/factsheet/" + id]);
  }

  getTournamentsLocation() {
    this.tournamentsService.getTournamentsLocations().pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.statelistData = JSON.parse(JSON.stringify(res.data.statelist));
      this.statelist = this.statelistData;
      this.cityListData = JSON.parse(JSON.stringify(res.data.citylist));
      this.cityList = this.cityListData;
      this.academyListData = JSON.parse(JSON.stringify(res.data.academylist));
      this.academylist = this.academyListData;
    });
  }

  onStateSelect(event) {
    if (event.checked.length > 0) {
      this.stateCode = [...event.checked.map(ele => ele.id)];
      this.stateName = [...event.checked.map(ele => ele.name)];
    } else {
      this.stateCode = [];
      this.stateName = [];
    }
    this.getAcademiesByLocation();

    this.refreshVisibleTournamentData();
  }
  

  onSearchState(event) {
    if (!this.statelistData) {
      return;
    }
    this.statelist = this.statelistData.filter(ele => (ele.name) ? ele.name.toLowerCase().includes(event.target.value.toLowerCase()) : null);
  }

  onAcademySelect(event) {
    if (event.checked.length > 0) {
      this.academyId = [...event.checked.map(ele => ele.id)];
    } else {
      this.academyId = [];
    }
    this.refreshVisibleTournamentData();
  }

  onSearchAcademy(event) {
    if (!this.academyListData) {
      return;
    }
    this.academylist = this.academyListData.filter(ele => (ele.name) ? ele.name.toLowerCase().includes(event.target.value.toLowerCase()) : null);
  }

  onCitySelect(event) {
    if (event.checked.length > 0) {
      this.cityCode = [...event.checked.map(ele => ele.id)];
      this.cityName = [...event.checked.map(ele => ele.name)];
    } else {
      this.cityCode = [];
      this.cityName = [];
    }
  this.getAcademiesByLocation();
    this.refreshVisibleTournamentData();
  }

 

  onSearchCity(event) {
    if (!this.cityListData) {
      return;
    }
    this.cityList = this.cityListData.filter(ele => (ele.name) ? ele.name.toLowerCase().includes(event.target.value.toLowerCase()) : null);
  }

  showloginDialog(id) {
    this.registeredtournamentdata = [];
    if (Object.keys(this.loggedInUser).length === 0) {
      this.route.navigate(['/']);
      return;
    }
    this.tournamentid = id;
    const matchingTournament = this.tournamentList.find(
      (tournament) => tournament.id === this.tournamentid
    );
    if (matchingTournament) {
      this.tournamentname = matchingTournament.name;
      this.selectedTournamentCityName = matchingTournament.citycode;
    } else {
    }
    if (this.selectedTournamentCityName == "Pune") {
      this.showPmdtaNumber = true;
    } else {
      this.showPmdtaNumber = false;
    }
    if (this.isLoggedIn) {
      if (this.loggedInUser.userdata.isProfileComplete === false) {
        this.welcomeLogin = true;
        return;
      }
      this.TournamentEntry = true;
      this.getTournamentCategoryData(this.tournamentid);
      this.getTournamentCategoryV2(this.tournamentid);
      this.fieldsFormArray.clear();
      this.selectedEntryFees = [];
      this.selectedCategoryAndAgeGroupList = [];
      this.disableCategories = [];
      this.addField();
      this.totalleftCash = this.walletBalance - this.totalEntryFee();
    } else {
      this.visible = true;
    }
  }

  async getTournamentCategoryV2(id) {
    this.tournamentService.getTournamentCategoryV2(id).pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        let categoryAndAgeGroupList = data['items'].reduce((tournamentCategories,category) => {
          tournamentCategories.push(...category.ageGroups);
          return tournamentCategories;
        },[]);
        if (this.registeredtournamentdata.length !== 0) {
          this.registeredtournamentdata.forEach(withdrawCategory => {
            const index = categoryAndAgeGroupList.findIndex(category => category.matchTypeId === withdrawCategory['matchTypeId'] && category.ageGroupId === withdrawCategory['ageGroupId']);
            if (index !== -1) {
              categoryAndAgeGroupList.splice(index,1);
            }
          })
        }
        this.originalCategoryAndAgeGroupList = JSON.parse(JSON.stringify(categoryAndAgeGroupList));
        this.categoryAndAgeGroupList = categoryAndAgeGroupList;
        this.registrationCategoryErrorMessage = null;

        this.categoryAndAgeGroupList.unshift({
          categoryName: "Select",
          matchTypeId: null,
          ageGroupId: null,
          value: null,
          entryFee: 0,
          maxPlayer: 0,
          tournamentCategoryId: null,
        });
        this.refreshCategoryLists();
        this.showNoCategories = !this.hasSelectableCategories;
      }
    },
    (err) => {
    });
  }

  // --- category capacity (slot-full) ---

  private toCategoryCount(value: any): number | null {
    if (value === null || value === undefined || value === '') { return null; }
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }

  isCategoryFull(category: any): boolean {
    if (!category) { return false; }
    const maxPlayer = this.toCategoryCount(category.maxPlayer);
    const playerCount = this.toCategoryCount(
      category.playercount ?? category.playerCount ?? category.currentCount
    );
    // missing data or no cap configured -> not full (keeps the "Select" placeholder usable)
    if (maxPlayer === null || playerCount === null || maxPlayer <= 0) { return false; }
    return playerCount >= maxPlayer;
  }

  refreshCategoryLists(): void {
    const list = this.categoryAndAgeGroupList || [];
    this.selectableCategoryList = list.filter(category => !this.isCategoryFull(category));
    this.fullCategoryList = list.filter(category => this.isCategoryFull(category));
  }

  get fullCategoryNames(): string {
    return this.fullCategoryList
      .map(category => category.categoryName || category.CategoryName)
      .filter(name => !!name)
      .join(', ');
  }

  get hasSelectableCategories(): boolean {
    // ignore the injected "Select" placeholder (matchTypeId/ageGroupId are null)
    return this.selectableCategoryList.some(category => category.matchTypeId && category.ageGroupId);
  }

  get hasFullSelectedCategory(): boolean {
    return (this.fieldsFormArray?.controls || []).some(
      (control: any) => this.isCategoryFull(control.get('categories')?.value)
    );
  }

  private isRealTournamentCategory(category: any): boolean {
    return !!(category && category.matchTypeId && category.ageGroupId);
  }

  private getCategoryKey(category: any): string {
    if (!category) { return ''; }
    return (
      category._id ||
      category.tournamentCategoryId ||
      category.id ||
      `${category.matchTypeId || ''}_${category.ageGroupId || ''}`
    ).toString();
  }

  private getCategoryDisplayName(category: any): string {
    if (!category) { return ''; }
    return category.categoryName || category.CategoryName || `${category.matchTypeName || ''} - ${category.ageGroupName || ''}`.trim();
  }

  private getCategoryDropdownSource(): any[] {
    const source = Array.isArray(this.originalCategoryAndAgeGroupList) && this.originalCategoryAndAgeGroupList.length
      ? this.originalCategoryAndAgeGroupList
      : (this.categoryAndAgeGroupList || []);
    return source.filter(category => this.isRealTournamentCategory(category));
  }

  private getSelectedCategoryKeysExcept(index: number): string[] {
    return (this.fieldsFormArray?.controls || [])
      .map((control: any, controlIndex: number) => controlIndex !== index ? this.getCategoryKey(control.get('categories')?.value) : '')
      .filter(key => !!key);
  }

  getSelectableCategoriesForField(index: number): any[] {
    const selectedInOtherFields = this.getSelectedCategoryKeysExcept(index);
    const currentCategory = this.fieldsFormArray?.controls[index]?.get('categories')?.value;
    const currentCategoryKey = this.getCategoryKey(currentCategory);
    const placeholder = (this.categoryAndAgeGroupList || []).find(category => !this.isRealTournamentCategory(category)) || {
      categoryName: "Select",
      matchTypeId: null,
      ageGroupId: null,
      value: null,
      entryFee: 0,
      maxPlayer: 0,
      tournamentCategoryId: null,
    };

    const selectableCategories = this.getCategoryDropdownSource().filter(category => {
      const categoryKey = this.getCategoryKey(category);
      const isCurrentCategory = currentCategoryKey && categoryKey === currentCategoryKey;
      return (isCurrentCategory || !selectedInOtherFields.includes(categoryKey)) && !this.isCategoryFull(category);
    });

    return [placeholder, ...selectableCategories];
  }

  getFullCategoryNamesForField(index: number): string {
    const selectedInOtherFields = this.getSelectedCategoryKeysExcept(index);

    return this.getCategoryDropdownSource()
      .filter(category => !selectedInOtherFields.includes(this.getCategoryKey(category)) && this.isCategoryFull(category))
      .map(category => this.getCategoryDisplayName(category))
      .filter(name => !!name)
      .join(', ');
  }

  get hasAnyTournamentCategory(): boolean {
    return this.getCategoryDropdownSource().length > 0;
  }

  get hasAddableCategories(): boolean {
    const selectedKeys = (this.fieldsFormArray?.controls || [])
      .map((control: any) => this.getCategoryKey(control.get('categories')?.value))
      .filter(key => !!key);

    return this.getCategoryDropdownSource().some(category => {
      const categoryKey = this.getCategoryKey(category);
      return !selectedKeys.includes(categoryKey) && !this.isCategoryFull(category);
    });
  }

  private getRegistrationCategoryErrorMessage(error: any): string {
    const message = error?.error?.message || error?.message || '';
    return message || 'Selected category is full. Please choose another category.';
  }

  hideWelcomeLoginDialog() {
    this.welcomeLogin = false;
  }

  showaddPartnerDialog(i) {
    this.resetEmailField();
    this.addPartner = true;
    this.addPartnerTermsAndConditions = false;
    this.TournamentEntry = false;
    this.partner_email_index = i;
    this.emailForm.get('phoneCode').setValue(this.countryCodeList.find(ele => ele.name === 'India'));
    this.selectedCountryCode = this.countryCodeList.find(ele => ele.name === 'India');
  }

  resetEmailField() {
    this.search_email = "";
    this.emailForm.reset();
  }

  addedPartner() {
    this.emailForm.get("mobileNumber").markAsTouched();
    this.loginemailid = this.loggedInUser.userdata.email;
    this.loginmobileNumber = this.loggedInUser.userdata.mobile;
    if (this.selectedTournamentCityName == "Pune") {
      this.showDoublePmdtaNumber = true;
    } else {
      this.showDoublePmdtaNumber = false;
    }
    if (this.emailForm.valid) {
      const doublePartnerDetails = {
        phoneCode: this.emailForm.value.phoneCode.phone_code,
        mobileNumber: this.emailForm.value.mobileNumber,
      }
      if (doublePartnerDetails.mobileNumber == this.loginmobileNumber) {
        this.duplicateEmailError = true;
      } else {
        this.duplicateEmailError = false;
        this.tournamentsService.getSearchbyEmail(doublePartnerDetails).pipe(takeUntil(this.destroy$)).subscribe((response) => {
          if (response.data.items.length > 0) {
            this.partneremailid = response.data.items[0].id;
            this.partneremailemail = response.data.items[0].fullName;
            this.myForm.value.fields[
              this.partner_email_index
            ].doublePlayerId = response.data.items[0].id;
            this.myForm.value.fields[
              this.partner_email_index
            ].doubleUserEmail = response.data.items[0].email;
            const doubleUserEmailControl =
              this.fieldsFormArray.controls[this.partner_email_index].get(
                "doubleUserEmail"
              );
            doubleUserEmailControl.setValue(this.partneremailemail);
            const doubleUserIdControl =
              this.fieldsFormArray.controls[this.partner_email_index].get(
                "doublePlayerId"
              );
            doubleUserIdControl.setValue(this.partneremailid);
            this.TournamentEntry = true;
            const selectedAgeGroupData = this.categoryAndAgeGroupList.find(
              (ageGroup) =>
                ageGroup.ageGroupId ===
              this.selectedAgeGroups[this.partner_email_index]
            );
            if (selectedAgeGroupData) {
              this.myForm.value.fields[this.partner_email_index].entryFee =
              selectedAgeGroupData.entryFee;
            }
            this.addPartner = false;
            this.TournamentEntry = true;
            this.emailerrormsg = false;
            setTimeout(()=>{
              this.elementRef.nativeElement.querySelector("#add_double_partner_" + this.partner_email_index).style.display = "none";
              this.elementRef.nativeElement.querySelector("#double_partner_" + this.partner_email_index).style.display = "block";
            },0);
          } else {
            this.emailerrormsg = true;
          }
        });
      }
    }
  }

  clearEmailErrors() {
    this.emailerrormsg = false;
  }

  Addcashdialog() {
    this.resetDialogStates();
    this.Addcashmodal = true;
    this.Walletdialog = true;
    this.addedAmount = null;
    this.totalleftCash = this.walletBalance - this.totalEntryFee();
  }

  resetDialogStates() {
    this.Addcashmodal = false;
    this.Walletdialog = false;
  }

  onCashSubmit(event: Event) {
    this.Walletdialog = true;
    event.preventDefault();
    this.added_amount = this.addCashForm.value.amount;
    this.submitted = true;
    if (this.addCashForm.invalid) {
      return;
    }
    var addCashData = this.addCashForm.value;
    addCashData["userId"] = this.loggedInUser.userdata.id;
    addCashData["walletType"] = "CASH";
    if (addCashData["amount"] > 0) {
      this.Addcashmodal = false;
      addCashData = JSON.stringify(addCashData, null, 4);
      const amt = addCashData["amount"];
      this.walletpaymentService.addWalletPayment(addCashData).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        let options: any = {
          key: environment.RAZORPAY_KEY_ID,
          amount: this.addCashForm.value.amount * 100, // amount should be in paise format to display Rs 1255 without decimal point
          currency: "INR",
          name: "TPL", // company name or product name
          description: "User Added Cash to wallet", // product description
          image: "../../../../assets/images/logo.png", // company logo or product image
          order_id: data.data["orderId"], // user_id created by you in backend
          modal: {
            escape: false,
          },
          notes: {
          },
          theme: {
            color: "#0c238a",
          },
        };
        options.handler = async (response, error) => {
          options.response = response;
          this.paymentId = response.razorpay_payment_id;
          await this.getUserBalance();
          this.thankYouMsg = true;
          setTimeout(() => {
            this.hideDiv();
            this.thankyouModal();
          }, 1000); // Hide the div after 2000 milliseconds (2 seconds)
        };
        options.modal.ondismiss = () => {};
        const rzp = new this.winRef.nativeWindow.Razorpay(options);
        rzp.open();
        return;
      });
    }
  }

  async getUserBalance() {
    if (this.isLoggedin) {
      var query ="?filterByDisable=false&filterByUserid=" +
      this.loggedInUser.userdata.id;
      this.userWalletService.getUserWalletList(query).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.walletBalance =
          data.data.totalCash - data.data.totalDeductedCash;
        this.totalCash = data.data.totalCash;
        this.totalCoins = data.data.totalCoins;
        if (this.walletBalance > this.totalEntryFee()) {
          this.onRadioClick();
          this.isRegisterButtonEnabled();
        } else {
        }
        if (this.thankYouMsg === true) {
          this.totalleftCash = this.walletBalance - this.totalEntryFee();
        }
        this.cdr.detectChanges();
      },
      (err) => {
        this.errorMessage = err.error.message;
      });
    }
  }

  catageclose(): void {
    this.TournamentEntry = false;
    this.termsAndConditions = false;
    this.renderer.removeClass(document.body, "p-overflow-hidden");
  }

  Withdrawclose(): void {
    this.WithdrawModal = false;
    this.renderer.removeClass(document.body, "p-overflow-hidden");
  }

  cashclose() {
    this.submitted = false;
  }

  thankyouModal() {
    const tournamentPlayerData = {
      category: this.myForm.value.fields,
      userId: this.loggedInUser.userdata.id,
      tournamentId: this.tournamentid,
      termsAndConditions: this.termsAndConditions,
    };
    if (this.isRadioButtonClicked) {
      if (this.walletBalance < this.totalEntryFee()) {
        this.addedAmount = Math.round(Number( (this.totalEntryFee() - this.walletBalance).toFixed(2)));
        this.addCashForm.controls['amount'].setValue(this.addedAmount);
        this.showAddMoneyMessage = false;
        this.TournamentEntry = false;
        this.Addcashdialog();  
        return;
      } else {
        this.showAddMoneyMessage = false;
      }
    } else {
      this.addedAmount = Number(this.totalEntryFee());
      this.addCashForm.controls['amount'].setValue(this.addedAmount);
      this.showAddMoneyMessage = false;
      this.TournamentEntry = false;
      this.Addcashdialog(); 
      return;
    }
    this.tournamentsService.getTtournamentPlayerDataV2(tournamentPlayerData).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.walletdata = res;
      let totalAmountPayable = this.walletdata.pricing.totalAmountPayable;
      let userWalletIds = [];
      let entryFee = 0;
      this.resetCountdown();
      if (this.walletdata.refundedCategories.length > 0) {
        this.refundTournamentCategoriesMessage = this.walletdata.message;
      }
      for (let x = 0;  x < this.walletdata.tournamentPlayerCategoryArr.length; x++) {
        entryFee += this.walletdata.tournamentPlayerCategoryArr[x].entryFee;
        const fixedSelectedSingleCategoryEntryFees = this.walletdata.tournamentPlayerCategoryArr[x].entryFee;
        let selectedSingleCategoryEntryFees = this.walletdata.tournamentPlayerCategoryArr[x].entryFee;
        if (this.fees?.platformFeeStatus) {
          if (this.fees?.platformFeeType === 'flat') {
            selectedSingleCategoryEntryFees += this.fees?.platformFee;
          } else {
             selectedSingleCategoryEntryFees += ((this.fees?.platformFee * fixedSelectedSingleCategoryEntryFees) / 100);
         }
        }
        if (this.fees?.convenienceFeeStatus) {
          if (this.fees?.convenienceFeeType === 'flat') {
            selectedSingleCategoryEntryFees += this.fees?.convenienceFee;
          } else {
            selectedSingleCategoryEntryFees += ((this.fees?.convenienceFee * fixedSelectedSingleCategoryEntryFees) / 100);
          }
        }
        const userwalletdata = {
          userId: this.walletdata.tournamentPlayerCategoryArr[x].userId,
          wallettype: "CASH",
          action: "SUBTRACT",
          //description: `Tournament Registration Fees`,
          description: `Registered for ${this.tournamentname} tournament`,
          // amount: this.walletdata.tournamentPlayerCategoryArr[x].entryFee,
          amount: selectedSingleCategoryEntryFees,
          tournamentplayer:
            this.walletdata.tournamentPlayerCategoryArr[x]._id,
        };
        this.tournamentsService.getUserwalletData(userwalletdata).pipe(takeUntil(this.destroy$)).subscribe((res2) => {
          userWalletIds.push(res2.id);
          if (this.walletdata.tournamentPlayerCategoryArr.length === userWalletIds.length) {
            // const fixedSelectedEntryFees = entryFee;
            // let selectedEntryFees = entryFee;
            // if (this.fees?.platformFeeStatus) {
            //   if (this.fees?.platformFeeType === 'flat') {
            //     selectedEntryFees += this.fees?.platformFee;
            //   } else {
            //      selectedEntryFees += ((this.fees?.platformFee * fixedSelectedEntryFees) / 100);
            //  }
            // }
            // if (this.fees?.convenienceFeeStatus) {
            //   if (this.fees?.convenienceFeeType === 'flat') {
            //     selectedEntryFees += this.fees?.convenienceFee;
            //   } else {
            //     selectedEntryFees += ((this.fees?.convenienceFee * fixedSelectedEntryFees) / 100);
            //   }
            // }
            const userInvoiceData = {
              tournamentId: this.tournamentid,
              // entryFee: entryFee,
              // entryFee: Math.round(selectedEntryFees),
              entryFee: Math.round(totalAmountPayable),
              userWalletIds: userWalletIds,
              tournamentCategories: this.myForm.value.fields,
              paymentId: this.paymentId,
            };
            this.userWalletService.addUserInvoice(userInvoiceData).pipe(takeUntil(this.destroy$)).subscribe((userInvoiceData) => {
              this.thanYoumodal = true;
              this.Walletdialog = false;
              this.countdownInProgress = true;
              this.cdr.detectChanges();
              const interval = setInterval(() => {
                this.countdown--;
                if (this.countdown === 0) {
                  clearInterval(interval);
                  this.countdownInProgress = false;
                  this.refundTournamentCategoriesMessage = null;
                  if (this.walletdata?.refundedCategories.length > 0) {
                    for (let i=0; i < this.walletdata?.refundedCategories.length; i++) {
                      this.wid = this.walletdata?.refundedCategories[i]['_id'];
                      if ((this.walletdata?.refundedCategories.length - 1) === i) {
                        this.isRefundTournamentCategoriesCompleted = true;
                      }
                      this.thankyouwithdraw();
                    }
                  } else {
                    let currentUrl = "/tournaments";
                    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
                    this.route.onSameUrlNavigation = "reload";
                    this.route.navigate([currentUrl]);
                  }
                }
                this.cdr.detectChanges();
              }, 1000);
            });
          }
        },
        (error) => {
          this.registrationCategoryErrorMessage = this.getRegistrationCategoryErrorMessage(error);
          this.errorMessage = this.registrationCategoryErrorMessage;
          this.Walletdialog = false;
          this.TournamentEntry = true;
          console.error("Error registering tournament player:", error);
        });
      }
    },
    (error) => {
      // Handle error (e.g., show an error message)
      this.registrationCategoryErrorMessage = this.getRegistrationCategoryErrorMessage(error);
      this.errorMessage = this.registrationCategoryErrorMessage;
      this.Walletdialog = false;
      this.TournamentEntry = true;
      console.error("Error registering tournament player:", error);
    });
  }

  onHideWalletDialog() {
    this.walletDialogTermsAndConditions = false;
  }

  openAddCategory() {
    this.WithdrawModal = false;
    this.getTournamentCategoryData(this.tournamentid);
    this.getTournamentCategoryV2(this.tournamentid);
    this.TournamentEntry = true;
  }

  registeredAddField() {
    this.fieldsFormArray.clear();
    this.addField();
    this.openAddCategory();
  }

  withdrawtournament(id, ldw) {
    this.WithdrawModal = true;
    this.tournamentid = id;
    const matchingTournament = this.tournamentList.find(
      (tournament) => tournament.id === this.tournamentid
    );
    if (matchingTournament) {
      this.tournamentname = matchingTournament.name;
      this.selectedTournamentCityName = matchingTournament.citycode;
    }
    this.tournamentsService.getwithdrawtournamentData(id).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.withdrawtournamentData = res;
        this.registeredtournamentdata = this.withdrawtournamentData.items;
        if (
          moment(this.currentDate).format("YYYY-MM-DD") >
          moment(ldw).format("YYYY-MM-DD")
        ) {
          this.withdraw_confirm_status = true;
        } else {
          this.withdraw_confirm_status = false;
        }
      },
      (error) => {
        console.error("Error registering tournament player:", error);
      }
    );
    // Enable the Confirm button only after the Withdraw button is clicked
    this.withdrawButtonClicked = true;
  }

  Withdrawconfirmmodal() {
    this.WithdrawcnfModal = true;
    this.WithdrawModal = false;
    this.isRefundTournamentCategoriesCompleted = true;
    this.cdr.detectChanges();
  }

  thankyouwithdraw() {
    this.WithdrawcnfModal = false;
    const wbody = {
      disable: true,
      playerId: this.loggedInUser.userdata.id,
    };
    this.tournamentsService.getwithdrawamount(this.wid, wbody).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.wid = "";
        this.tname = "";
        this.mtn = "";
        this.agn = "";
        this.thankwithdraw = true;
        this.countdownInProgress = true;
        this.cdr.detectChanges();
        if (this.isRefundTournamentCategoriesCompleted) {
          this.resetCountdown();
          const interval = setInterval(() => {
            this.countdown--;
            if (this.countdown === 0) {
              clearInterval(interval);
              this.countdownInProgress = false;
              //window.location.reload();
              let currentUrl = "/tournaments";
              this.route.routeReuseStrategy.shouldReuseRoute = () => false;
              this.route.onSameUrlNavigation = "reload";
              this.route.navigate([currentUrl]);
            }
            this.cdr.detectChanges();
          }, 1000);
        }
      },
      (error) => {
        console.error("Error updating tournament player:", error);
      }
    );
  }

  onRadioClick() {
    this.isRadioButtonClicked = !this.isRadioButtonClicked;
    this.displayCashMs = true;
    this.totalleftCash = this.walletBalance - this.totalEntryFee();
  }

  withdraw_select(id: number, tname, mtn, agn) {
    this.withdrawButtonClicked = false;
    this.tname = tname;
    this.mtn = mtn;
    this.agn = agn;
    this.wid = id;
  }

  getWebBanner() {
    let query =
      "?filterByDisable=false&filterByStatus=true&filterBySlug=tournament";
    this.bannerService.getbannerList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.bannerList.forEach((element) => {
          this.webBannerImageList = element.banner_image;
          this.mobileBannerImageList = element.mobile_banner_image;
        });
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  hideDiv() {
    this.thankYouMsg = false;
  }

  loadPastTournament(event: LazyLoadEvent) {
    this.tabLoading['past'] = true;
    this.tabLoaded['past'] = true;
    this.lazyLoadEventPastTournament = event;
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    let query =
      "filterByDisable=false&filterByStatus=true&filterByPastTournament=true";
    if (event !== undefined && !this.onTournamentTabChange) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }      
    }    
    if (this.tournamentName !== '' && this.tournamentName !== null) {
      query += "&filterByName=" + this.tournamentName;
    }
    if (this.academyId.length > 0) {
      query += "&filterByAcademyIds=" + this.academyId;
    }
    if (this.stateName.length > 0) {
      query += "&filterByStateNames=" + this.stateName;
    }
    if (this.cityName.length > 0) {
      query += "&filterByCityNames=" + this.cityName;
    }
    if (this.selectedcourtType != null) {
      query += "&filterByCourtType=" + this.selectedcourtType;
    }
    if (this.selectedMonth != null) {
      query += "&filterByMonth=" + this.selectedMonth;
    }
    if (this.selectedYear.length > 0 && this.isYearFilterSelected) {
      query += "&filterByYears=" + this.selectedYear;
    }
    if (this.filterByAgeCategorySelected.length > 0) {
      query += "&filterByAgeGroupId=" + this.filterByAgeCategorySelected;
    }
    if (this.filterByMatchCategorySelected.length > 0) {
      query += "&filterByMatchGroupId=" + this.filterByMatchCategorySelected;
    }
    if (this.selectedStartDateRange != null) {
      query += "&filterByStartDateRange=" + this.selectedStartDateRange;
    }
    if (this.latitude !== null) {
      query += "&filterByLatitude=" + this.latitude;
    }
    if (this.longitude !== null) {
      query += "&filterByLongitude=" + this.longitude;
    }
    this.pageNumberFirst = pagenumber;
    this.pageLimitFirst = rows;
      query += "&pageSize=" +  rows + "&pageNumber=" + pagenumber;
    if (this.sortByPriceValue !== null) {
      query += "&sortByPrice=entryFee&orderByPrice=" + this.sortByPriceValue;
    } else if (this.latitude !== null && this.longitude !== null) {
      query += "&sortBy=distance&orderBy=ASC";
    } else {
      query += "&sortBy=startdate&orderBy=DESC";
    }
    this.tournamentsService.getTournamentsListWithoutAuth(query).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        if (event !== undefined) {
          window.scroll(0, 0);
        }
        this.loading = false;
        this.pastTournamentList = data.data.items;
        if (this.cityName.includes("Pune")) {
          this.showPmdtaNumber = true;
        } else {
          this.showPmdtaNumber = false;
        }
        this.pastTotalRecords = data.data.totalCount;
        this.pastTournamentList.forEach((element) => {
          element.isViewMore = false;
          this.imagedataa = element["academyPic"];
          let groupdt = [];
          if (element["tournamentCategories"]) {
            if (element["tournamentCategories"].length > 0) {
              element["tournamentCategories"].forEach((tmp) => {
                groupdt.push(tmp["matchtypeData"][0]["name"]);
              });
              element.matchtype = groupdt.toString();
            } else {
              element.matchtype = "";
            }
          }
        let cateArray = [];
        if (element.tournamentCategories) {
          element.tournamentCategories.forEach((element) => {
            cateArray.push(
              element.ageGroupData[0].name + " " + element.matchtypeData[0].name
            );
          });
        }
        const heading =
            "_Join_" +
            " _*" +
            element.name +
            "*_ " +
            "_and start climbing up the ranking ladder to win the RTG Scholarship!🎾🏆_ ";
          const subheading = "*🎾Categories:* " + cateArray.join(", ");
          const lastdate =
            "*🗓️Last Date Of Registration:* " +
            moment(element.lastdateofregistration).format("DD-MM-YYYY");
          const startdate =
            "*🗓️Tournament Date:* " +
            moment(element.startdate).format("DD-MM-YYYY");
          const location =
            "*📍Location:* " +
            element.address +
            ", " +
            element.cityname +
            ", " +
            element.statename +
            ", " +
            element.zipcode;
          const link =
            "*Tap on the link to Register:* " +
            environment.frontEnd.domain +
            "/tournaments/factsheet/" +
            element.id;
          const org =
            "*For any queries Contact* " +
            "*" +
            element.academyName +
            "*" +
            " at " +
            "+91 " +
            element.organizercontactnumber;
          const seeyou = "_*Register Now only on the TPL App*_";  
          // Construct the WhatsApp sharing URL
            const message = encodeURIComponent(
              heading +
                "\n" +
                "\n" +
                subheading +
                "\n" +
                lastdate +
                "\n" +
                startdate +
                "\n" +
                location +
                "\n" +
                link +
                "\n" +
                "\n" +
                org +
                "\n" +
                "\n" +
                seeyou +
                "\n" +
                "\n"
            );
          element.shareurl = `https://api.whatsapp.com/send?text=${message}`;
          let tmp = this.courtTypeList.find(
            (o) => o.value === element.courttype
          );
          if (tmp != undefined) {
            element.court = tmp.label;
          } else {
            element.court = "";
          }
          let tmpcat = [];
          let pointsData = [];
          let entryFeeData = [];
          let t = element.tournamentCategories;
          if (t != undefined) {
            t.forEach((catelement) => {
              const matchCategory = [
                {
                  matchTypeCategoryId: catelement.matchtypeData[0]?._id,
                  matchTypeCategoryName: catelement.matchtypeData[0]?.name,
                  ageGroupTypeCategoryId: catelement.ageGroupData[0]?._id,
                  ageGroupTypeCategoryName: catelement.ageGroupData[0]?.name,
                }
              ]
              tmpcat.push(matchCategory);
              pointsData.push(catelement.pointStructureData);
              entryFeeData.push(catelement.entryFee);
            });
          }
          let minimumEntryFee = (entryFeeData.length > 0) ? Math.min(...entryFeeData) : null;
          let maximumEntryFee = (entryFeeData.length > 0) ? Math.max(...entryFeeData) : null;
          element.minimumEntryFee = minimumEntryFee;
          element.maximumEntryFee = maximumEntryFee;
          let uniqueData = [];
          let uniqueIds = {};
          tmpcat.forEach((item) => {
            if (item.length > 0) {
              // if (!uniqueIds[item[0]["matchTypeCategoryName"]]) {
              //   uniqueIds[item[0]["matchTypeCategoryName"]] = true;
              //   uniqueData.push(item[0]["matchTypeCategoryName"] + ' ' + item[0]["ageGroupTypeCategoryName"]);
              // }
              uniqueData.push(item[0]["matchTypeCategoryName"] + ' ' + item[0]["ageGroupTypeCategoryName"]);
            }
          });
          let uniquePointsData = [];
          pointsData.forEach((item) => {
            if (!uniquePointsData.includes(item[0]['name'].replace(' Points', ''))) {
              uniquePointsData.push(item[0]['name'].replace(' Points', ''));
            }
          })
          element.matchDataName = uniqueData.length > 0 ? uniqueData : null;
          element.pointsDataName = uniquePointsData;
        });
        this.tabLoading['past'] = false;
      },
      (err) => {
        this.errorMessage = err.error.message;
        this.tabLoading['past'] = false;
      }
    );
    this.onTournamentTabChange = false;
  }

  loadCurrentTournament(event: LazyLoadEvent) {
    this.tabLoading['current'] = true;
    this.tabLoaded['current'] = true;
    const tabMapping = ['past', 'current', 'upcoming'];
    this.lazyLoadEventCurrentTournament = event;
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    let query =
      "filterByDisable=false&filterByStatus=true&filterByCurrentTournament=true";
    if (event !== undefined && !this.onTournamentTabChange) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }
    if (this.tournamentName !== '' && this.tournamentName !== null) {
      query += "&filterByName=" + this.tournamentName;
    }
    if (this.academyId.length > 0) {
      query += "&filterByAcademyIds=" + this.academyId;
    }
    if (this.stateName.length > 0) {
      query += "&filterByStateNames=" + this.stateName;
    }
    if (this.cityName.length > 0) {
      query += "&filterByCityNames=" + this.cityName;
    }
    if (this.selectedcourtType != null) {
      query += "&filterByCourtType=" + this.selectedcourtType;
    }
    if (this.selectedMonth != null) {
      query += "&filterByMonth=" + this.selectedMonth;
    }
    if (this.selectedYear.length > 0 && this.isYearFilterSelected) {
      query += "&filterByYears=" + this.selectedYear;
    }
    if (this.filterByAgeCategorySelected.length > 0) {
      query += "&filterByAgeGroupId=" + this.filterByAgeCategorySelected;
    }
    if (this.filterByMatchCategorySelected.length > 0) {
      query += "&filterByMatchGroupId=" + this.filterByMatchCategorySelected;
    }
    if (this.selectedStartDateRange != null) {
      query += "&filterByStartDateRange=" + this.selectedStartDateRange;
    }
    if (this.latitude !== null) {
      query += "&filterByLatitude=" + this.latitude;
    }
    if (this.longitude !== null) {
      query += "&filterByLongitude=" + this.longitude;
    }
    this.pageNumberFirst = pagenumber;
    this.pageLimitFirst = rows;
      query += "&pageSize=" +  rows + "&pageNumber=" + pagenumber;
    if (this.sortByPriceValue !== null) {
      query += "&sortByPrice=entryFee&orderByPrice=" + this.sortByPriceValue;
    } else if (this.latitude !== null && this.longitude !== null) {
      query += "&sortBy=distance&orderBy=ASC";
    } else {
      query += "&sortBy=startdate&orderBy=ASC";
    }
    this.tournamentsService.getTournamentsListWithoutAuth(query).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        if (event !== undefined) {
          window.scroll(0, 0);
        }
        this.loading = false;
        this.currentTournamentList = data.data.items;
        this.currentTotalRecords = data.data.totalCount;
        this.currentTournamentList.forEach((element) => {
          element.isViewMore = false;
          this.imagedataa = element["academyPic"];
          let groupdt = [];
          if (element["tournamentCategories"]) {
            if (element["tournamentCategories"].length > 0) {
              element["tournamentCategories"].forEach((tmp) => {
                if (tmp["matchtypeData"].length > 0) {
                  groupdt.push(tmp["matchtypeData"][0]["name"]);
                }
              });
              element.matchtype = groupdt.toString();
            } else {
              element.matchtype = "";
            }
          }          
        let cateArray = [];
        if (element.tournamentCategories) {
          element.tournamentCategories.forEach((element) => {
            if (element.ageGroupData.length > 0 && element.matchtypeData.length > 0) {
              cateArray.push(
                element.ageGroupData[0].name + " " + element.matchtypeData[0].name
              );
            }
          });
        }
        const heading =
            "_Join_" +
            " _*" +
            element.name +
            "*_ " +
            "_and start climbing up the ranking ladder to win the RTG Scholarship!🎾🏆_ ";
          const subheading = "*🎾Categories:* " + cateArray.join(", ");
          const lastdate =
            "*🗓️Last Date Of Registration:* " +
            moment(element.lastdateofregistration).format("DD-MM-YYYY");
          const startdate =
            "*🗓️Tournament Date:* " +
            moment(element.startdate).format("DD-MM-YYYY");
          const location =
            "*📍Location:* " +
            element.address +
            ", " +
            element.cityname +
            ", " +
            element.statename +
            ", " +
            element.zipcode;
          const link =
            "*Tap on the link to Register:* " +
            environment.frontEnd.domain +
            "/tournaments/factsheet/" +
            element.id;
          const org =
            "*For any queries Contact* " +
            "*" +
            element.academyName +
            "*" +
            " at " +
            "+91 " +
            element.organizercontactnumber;
          const seeyou = "_*Register Now only on the TPL App*_";  
          // Construct the WhatsApp sharing URL
            const message = encodeURIComponent(
              heading +
                "\n" +
                "\n" +
                subheading +
                "\n" +
                lastdate +
                "\n" +
                startdate +
                "\n" +
                location +
                "\n" +
                link +
                "\n" +
                "\n" +
                org +
                "\n" +
                "\n" +
                seeyou +
                "\n" +
                "\n"
            );
          element.shareurl = `https://api.whatsapp.com/send?text=${message}`;          
          let tmp = this.courtTypeList.find(
            (o) => o.value === element.courttype
          );
          if (tmp != undefined) {
            element.court = tmp.label;
          } else {
            element.court = "";
          }
          let tmpcat = [];
          let pointsData = [];
          let entryFeeData = [];
          let t = element.tournamentCategories;
          t.forEach((catelement) => {
            const matchCategory = [
              {
                matchTypeCategoryId: catelement.matchtypeData[0]?._id,
                matchTypeCategoryName: catelement.matchtypeData[0]?.name,
                ageGroupTypeCategoryId: catelement.ageGroupData[0]?._id,
                ageGroupTypeCategoryName: catelement.ageGroupData[0]?.name,
              }
            ]
            tmpcat.push(matchCategory);
            pointsData.push(catelement.pointStructureData);
            entryFeeData.push(catelement.entryFee);
            if (this.cityName.includes("Pune")) {
              this["showPmdtaNumber"] = true;
            } else {
              this["showPmdtaNumber"] = false;
            }
          });
          let minimumEntryFee = (entryFeeData.length > 0) ? Math.min(...entryFeeData) : null;
          let maximumEntryFee = (entryFeeData.length > 0) ? Math.max(...entryFeeData) : null;
          element.minimumEntryFee = minimumEntryFee;
          element.maximumEntryFee = maximumEntryFee;
          let uniqueData = [];
          let uniqueIds = {};
          tmpcat.forEach((item) => {
            if (item.length > 0) {
            //   if (!uniqueIds[item[0]["matchTypeCategoryName"]]) {
            //     uniqueIds[item[0]["matchTypeCategoryName"]] = true;
            //     uniqueData.push(item[0]["matchTypeCategoryName"] + ' ' + item[0]["ageGroupTypeCategoryName"]);
            //   }
            uniqueData.push(item[0]["matchTypeCategoryName"] + ' ' + item[0]["ageGroupTypeCategoryName"]);
            }
          });          
          let uniquePointsData = [];
          pointsData.forEach((item) => {
            if (!uniquePointsData.includes(item[0]['name'].replace(' Points', ''))) {
              uniquePointsData.push(item[0]['name'].replace(' Points', ''));
            }
          })
          element.matchDataName = uniqueData.length > 0 ? uniqueData : null;
          element.pointsDataName = uniquePointsData;
        });
        this.tabLoading['current'] = false;
      },
      (err) => {
        this.errorMessage = err.error.message;
        this.tabLoading['current'] = false;
      }
    );
    this.onTournamentTabChange = false;
  }

  onTabChange(event: any) {   
    this.onTournamentTabChange = true;
    this.activeTab = event.index;
    this.pageNumberFirst = 1;
    this.pageLimitFirst = 10;
    this.loadActiveTournamentTabWhenLocationReady();
  }

  onTermsAndConditionsSelect(event) {
    if (event.checked) {
      this.termsAndConditionsCheck = true;
      this.showTermsAndConditionError = false;
      this.termsAndConditions = true;
    } else {
      this.termsAndConditionsCheck = false;
      this.termsAndConditions = false;
    }
  }

  onAddPartnerTermsAndConditionsSelect(event) {
    if (event.checked) {
      this.addPartnerTermsAndConditions = true;
    } else {
      this.addPartnerTermsAndConditions = false;
    }
  }

  onWalletDialogTermsAndConditionsSelect(event) {
    if (event.checked) {
      this.walletDialogTermsAndConditions = true;
    } else {
      this.walletDialogTermsAndConditions = false;
    }
  } 
 
  getCountryCodes() {
    this.commonService.getCountryList().pipe(takeUntil(this.destroy$)).subscribe((data) => { 
      this.countryCodeList = data.data.items;
    })
  }

  setCountryCode(event) {
    this.selectedCountryCode = event.value;
  }

  showMobileFilter() {
    this.mobilFilter = true;
  }

  shortFilter() {
    this.shortingModal = true;
  }

  onDownloadClick(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright'){
    this.position = position;
    this.downloadModal = true; 
  }

  ngOnDestroy() {
    if (this.listingObserver) {
      this.listingObserver.disconnect();
    }
    this.destroy$.next();
    this.destroy$.complete();
    this.renderer.removeClass(document.body, 'tournamentPage');
  }


  getAcademiesByLocation() {

    let query =
      "?filterByDisable=false" +
      "&filterByStatus=true" +
      "&pageSize=100" +
      "&pageNumber=1";

    if (this.stateName.length > 0) {
      query += "&filterByStateNames=" + this.stateName.join(",");
    }

    if (this.cityName.length > 0) {
      query += "&filterByCityNames=" + this.cityName.join(",");
    }

    this.tournamentService
      .getAcademyFiltersByStateCity(query)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.academylist = res.data.items || [];

      });
  }

  //Calculate the PlatformFee  in Amount
  getPlatformFeeAmount(): number {
    const entryFee = this.selectedEntryFees.reduce(
      (total, fee) => total + fee,
      0
    );
    if (!this.fees?.platformFeeStatus) {
      return 0;
    }
    if (this.fees?.platformFeeType === 'flat') {
      return Number(this.fees?.platformFee || 0);
    }
    return (Number(this.fees?.platformFee || 0) * entryFee) / 100;
  }

  //Calculate the Conveniencefee in Amount
  getConvenienceFeeAmount(): number {
    const entryFee = this.selectedEntryFees.reduce(
      (total, fee) => total + fee,
      0
    );
    if (!this.fees?.convenienceFeeStatus) {
      return 0;
    }
    if (this.fees?.convenienceFeeType === 'flat') {
      return Number(this.fees?.convenienceFee || 0);
    }
    return (Number(this.fees?.convenienceFee || 0) * entryFee) / 100;
  }

}
